import { useParams } from '@tanstack/react-router'
import { SupportTicketWorkView } from '@/shell/services/support'

/**
 * Full-page per-ticket working view (email-thread-viewer sprint).
 * Thin wrapper mirroring QuoteDetailPage — reads `ticketId` from the
 * route param and renders the shared work view from the support service.
 */
export function SupportTicketPage() {
  const params = useParams({ strict: false }) as { ticketId?: string }
  const ticketId = params.ticketId
  if (!ticketId) {
    return <div className="p-8 text-tertiary">Invalid ticket id.</div>
  }
  return <SupportTicketWorkView ticketId={ticketId} />
}
